import { ComponentStatus } from '@Types';

const SPECIAL_COMPONENTS = [
	'aws.greengrass.Nucleus',
	'NodeRuntimeLinux',
	'Nodejs',
];
const SPECIAL_COMPS_VALID_STATUS = new Set([
	ComponentStatus.Finished,
	ComponentStatus.Running,
]);

export const getIsComponentInGoodState = (
	componentName: string,
	currentStatus: ComponentStatus,
): boolean => {
	const isSpecialComponent = SPECIAL_COMPONENTS.some(sc =>
		componentName.startsWith(sc),
	);

	if (isSpecialComponent) {
		return SPECIAL_COMPS_VALID_STATUS.has(currentStatus);
	} else {
		return currentStatus === ComponentStatus.Running;
	}
};
